import{correctNode as r}from"./correctFocus.js";var n=function(n){return n[0]&&n.length>1?r(n[0],n):n[0]},t=function(n,t){return n.indexOf(r(t,n))};export{n as pickFirstFocus,t as pickFocusable};
//# sourceMappingURL=firstFocus.js.map
